import register from '../register';

function init() {
  const form = document.querySelector('form');
  form?.addEventListener( 'submit', onSubmit );
}

// Use default browser form submit behavior, but add loader on submit
function onSubmit( e ) {
  const submit = e.target.querySelector('button[type="submit"]');

  submit.disabled = true;
  submit.classList.add('loading');
}


register( 'redeem-tango', init );

export default undefined;
